module.exports = __webpack_public_path__ + "static/img/our-people-company-values-grid-3.c26dfe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-values-grid-3.jpg
// module id = od3S
// module chunks = 0